module.exports = __webpack_public_path__ + "img/portrait-five.65173362.png";